module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sort_orders_by":"Sort orders by"},"id":{"sort_orders_by":"Urutkan berdasarkan"}}')
  delete Component.options._Ctor
}
